/* Neues Kartendesign (New-Updated__design): Titel, Checklisten und Preise pro Grid-Reihe auf eine Höhe bringen.
   Der Use-Case-Hinweis schiebt den Titel nach unten (Ausgleich per margin-top am Titel), zweizeilige Titel
   schieben die Liste nach unten (Ausgleich per margin-bottom am Titel); der Reassurance-Hinweis der Hauptempfehlung schiebt den Preis nach oben
   (Ausgleich per min-height am unteren Block). Preis und Button sitzen per CSS am unteren Rand. */
(() => {
  // Wird pro Section eingebunden (main-collection, featured-collection), soll aber nur einmal laufen
  if (window.wdCollectionCardRows) return;
  window.wdCollectionCardRows = true;

  const LIST = '.New-Updated__design .collection__results product-list';
  const TITLE = '.product-card__title';
  const DESC = '.custom-product-card__desc.updated-desc';
  const BOTTOM = '.collectio-listing__wrapperbottom';

  function alignList(list) {
    const cards = [...list.querySelectorAll('product-card')].map((card) => ({
      card,
      title: card.querySelector(TITLE),
      desc: card.querySelector(DESC),
      bottom: card.querySelector(BOTTOM),
    }));

    cards.forEach(({ title, bottom }) => {
      if (title) {
        title.style.marginTop = '';
        title.style.marginBottom = '';
      }
      if (bottom) bottom.style.minHeight = '';
    });

    if (getComputedStyle(list).gridTemplateColumns.split(' ').length < 2) return;

    // offsetTop statt getBoundingClientRect: reveal-items schiebt die Karten beim Einblenden versetzt per translateY
    const rows = new Map();
    cards.forEach((item) => {
      const key = item.card.offsetTop;
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(item);
    });

    rows.forEach((row) => {
      if (row.length < 2) return;

      // Titel pro Reihe auf eine Höhe: der Use-Case-Hinweis unter dem Bild ist je Karte unterschiedlich hoch
      // oder fehlt ganz, der Ausgleich kommt als margin-top auf den Titel (vor dem Checklisten-Ausgleich,
      // weil der auf den Titel-Positionen aufbaut)
      const withTitle = row.filter((item) => item.title);
      withTitle.forEach((item) => {
        item.titleOffset = item.title.getBoundingClientRect().top - item.card.getBoundingClientRect().top;
      });
      const maxTitleOffset = Math.max(...withTitle.map((item) => item.titleOffset));
      withTitle.forEach((item) => {
        const diff = maxTitleOffset - item.titleOffset;
        if (diff < 1) return;
        const base = parseFloat(getComputedStyle(item.title).marginTop) || 0;
        item.title.style.marginTop = `${base + diff}px`;
      });

      const withDesc = row.filter((item) => item.title && item.desc && item.desc.offsetHeight);
      withDesc.forEach((item) => {
        item.offset = item.desc.getBoundingClientRect().top - item.card.getBoundingClientRect().top;
      });
      const maxOffset = Math.max(...withDesc.map((item) => item.offset));
      withDesc.forEach((item) => {
        const diff = maxOffset - item.offset;
        if (diff < 1) return;
        const base = parseFloat(getComputedStyle(item.title).marginBottom) || 0;
        item.title.style.marginBottom = `${base + diff}px`;
      });

      const withBottom = row.filter((item) => item.bottom);
      const maxBottom = Math.max(...withBottom.map((item) => item.bottom.offsetHeight));
      withBottom.forEach((item) => {
        if (maxBottom - item.bottom.offsetHeight >= 1) item.bottom.style.minHeight = `${maxBottom}px`;
      });
    });
  }

  let frame = 0;
  function alignAll() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => document.querySelectorAll(LIST).forEach(alignList));
  }

  // Breite der Liste statt window.resize: auch ein- oder ausgeblendete Scrollbalken ändern den Zeilenumbruch.
  // Höhenänderungen ignorieren, die entstehen durch den Ausgleich selbst.
  const widths = new WeakMap();
  const resizeObserver = new ResizeObserver((entries) => {
    let changed = false;
    entries.forEach((entry) => {
      const width = Math.round(entry.contentRect.width);
      if (widths.get(entry.target) !== width) {
        widths.set(entry.target, width);
        changed = true;
      }
    });
    if (changed) alignAll();
  });

  // Titel brechen nach dem Nachladen der Webfont neu um, ohne dass sich die Listenbreite ändert.
  // margin-bottom und min-height aus dem Ausgleich ändern die Größe dieser Elemente nicht.
  const contentObserver = new ResizeObserver(alignAll);
  const CONTENT = `${TITLE}, ${DESC}, .bsi0015-usecase, .bsi0015-reassurance`;

  function observeLists() {
    document.querySelectorAll(LIST).forEach((list) => {
      resizeObserver.observe(list);
      list.querySelectorAll(CONTENT).forEach((el) => contentObserver.observe(el));
    });
    alignAll();
  }

  window.addEventListener('load', alignAll);
  if (document.fonts) document.fonts.ready.then(alignAll);

  // Filter und Sortierung ersetzen per AJAX den ganzen Inhalt der Shopify-Section (facet-form.js: replaceChildren),
  // daher die Section selbst beobachten, nicht .collection__results
  const sections = new Set();
  document.querySelectorAll('.New-Updated__design .collection__results').forEach((results) => {
    sections.add(results.closest('.shopify-section') || results);
  });
  sections.forEach((section) => {
    new MutationObserver(observeLists).observe(section, { childList: true, subtree: true });
  });

  observeLists();
})();
